<script setup lang="ts">
import ActionSource from "@/components/action/ActionSource.vue";

import DeleteMenuItem from "./DeleteMenuItem.vue";
import TextMenuItem from "./TextMenuItem.vue";
</script>

<template>
  <ActionSource value="context-menu">
    <TextMenuItem />
    <DeleteMenuItem />
  </ActionSource>
</template>
